import React from "react";
import Widget from "components/Widget";
import { Tabs, Row, Col } from "antd";
import AllBankListTable from "./AllBankListTable";
const TicketList = (props) => {
  return (
    <AllBankListTable
      isDigitHomePage={props.isDigitHomePage}
      forUseHomePage={props.forUseHomePage}
    />
  );
};

export default TicketList;
